import React, { Component } from "react";
import PropTypes from "prop-types";
import { FormattedMessage } from "react-intl";
import { connect } from "react-redux";

import messages from "components/messagesDescription";
import ResultDetail from "./ResultDetail";
import HraResultRiskType from "./hraResultRiskType";

class HealthReview extends Component {
  static propTypes = {
    hideHraRecommendation: PropTypes.bool,
    riskDomainList: PropTypes.array,
    currentRiskDomain: PropTypes.string,
    riskItemClicked: PropTypes.func.isRequired,
  };

  render() {
    const {
      hideHraRecommendation,
      riskDomainList,
      riskItemClicked,
      currentRiskDomain,
    } = this.props;

    return (
      <article className="card">
        <header>
          <h3>
            <FormattedMessage {...messages.healthReviewHraResultsDescription} />
          </h3>
        </header>
        <section>
          {!hideHraRecommendation && (
            <p>
              <FormattedMessage {...messages.learnMoreWithButtonsDescription} />
            </p>
          )}
          <div className="apl-legend">
            <h4>
              <FormattedMessage {...messages.colourGuideHeaderDescription} />
            </h4>
            <ul>
              <li className="apl-legend__risk apl-legend__risk--high">
                <FormattedMessage {...messages.unhealthyHighRiskDescription} />
              </li>
              <li className="apl-legend__risk apl-legend__risk--moderate">
                <FormattedMessage {...messages.cautionModerateRiskDescription} />
              </li>
              <li className="apl-legend__risk apl-legend__risk--low">
                <FormattedMessage {...messages.healthLowRiskDescription} />
              </li>
            </ul>
          </div>
          <div className="grid__wrapper apl-risk-factors">
            {riskDomainList &&
              riskDomainList.map(
                item =>
                  item && (
                    <HraResultRiskType
                      key={`riskItem_${item.name}`}
                      item={item}
                      currentRiskDomain={currentRiskDomain}
                      riskItemClicked={riskItemClicked}
                    />
                  )
              )}
          </div>
          <ResultDetail />
        </section>
      </article>
    );
  }
}

const mapStateToProps = ({ hraResult, hraResultDetail }) => {
  const { hideHraRecommendation, riskDomainList } = hraResult;
  const { currentRiskDomain } = hraResultDetail;

  return {
    hideHraRecommendation,
    riskDomainList,
    currentRiskDomain,
  };
};

export default connect(mapStateToProps)(HealthReview);



// WEBPACK FOOTER //
// ./components/wellness/lifestyleAgeing/results/healthReview.jsx